var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiCopyGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 2.33335C0.666626 1.89133 0.842221 1.4674 1.15478 1.15484C1.46734 0.842282 1.89127 0.666687 2.33329 0.666687H10.6666C11.1087 0.666687 11.5326 0.842282 11.8451 1.15484C12.1577 1.4674 12.3333 1.89133 12.3333 2.33335V5.66669H15.6666C16.1087 5.66669 16.5326 5.84228 16.8451 6.15484C17.1577 6.4674 17.3333 6.89133 17.3333 7.33335V15.6667C17.3333 16.1087 17.1577 16.5326 16.8451 16.8452C16.5326 17.1578 16.1087 17.3334 15.6666 17.3334H7.33329C6.89127 17.3334 6.46734 17.1578 6.15478 16.8452C5.84222 16.5326 5.66663 16.1087 5.66663 15.6667V12.3334H2.33329C1.89127 12.3334 1.46734 12.1578 1.15478 11.8452C0.842221 11.5326 0.666626 11.1087 0.666626 10.6667V2.33335ZM7.33329 12.3334V15.6667H15.6666V7.33335H12.3333V10.6667C12.3333 11.1087 12.1577 11.5326 11.8451 11.8452C11.5326 12.1578 11.1087 12.3334 10.6666 12.3334H7.33329ZM10.6666 10.6667V2.33335H2.33329V10.6667H10.6666Z",
    fill: "#3AB54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiCopyGreen);
export default __webpack_public_path__ + "static/media/mi_copy_green.56e062305457cadf38d409b3caccaa01.svg";
export { ForwardRef as ReactComponent };